import { Component, OnInit, SimpleChanges, Input, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { SignaturePadComponent } from '../../../commons/signature-pad/signature-pad.component';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DocumentService } from '../../../services/document.service';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { saveAs } from "file-saver";
import * as moment from 'moment';
// import * as xlsx from 'xlsx';
@Component({
  selector: 'app-medical-checklist',
  templateUrl: './medical-checklist.component.html',
  styleUrls: ['./medical-checklist.component.scss']
})
export class MedicalChecklistComponent implements OnInit {
  @Input('singleJob') job
  medicalChecklistForm
  singleJobDetails
  clientsList = []
  locationDetails
  locationList = []
  selectedClients = []
  medicalSign = false
  jobId
  loading
  medicalFormDetails
    isEdit = false
    // loading;
    user: any;
  constructor(
    public dialog: MatDialog,
    public formBuilder: FormBuilder,
    public documentService: DocumentService,
    public _snackBar: MatSnackBar,
    private router: Router,
  ) { }

  // @ViewChild({ 'medicalCheckList' , static: false }) medicalCheckList: ElementRef
  @ViewChild('medicalCheckList', { static: false }) medicalCheckList: ElementRef;

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.job && changes.job.currentValue) {
      this.singleJobDetails = changes.job.currentValue
      this.clientsList = this.singleJobDetails.clients
      console.log("what is the single job details", this.singleJobDetails);
      this.jobId = this.singleJobDetails._id
      this.getMedicalFormValue()
    }


  }

  ngOnInit() {
      this.user = JSON.parse(localStorage.getItem('userRoles'))
    this.createForm()
  }




  // FORM GROUP



  createForm(details?) {


    this.medicalChecklistForm = new FormGroup({
      clients: new FormControl((details && details.clients) ? details.clients : ''),
      locations: new FormControl((details && details.locations) ? details.locations : ''),
      officers: new FormControl((details && details.officers) ? details.officers : ''),
      startDate: new FormControl((details && details.startDate) ? details.startDate : ''),
      roomWork: new FormControl((details && details.roomWork) ? details.roomWork : ''),
      roomWork1: new FormControl((details && details.roomWork1) ? details.roomWork1 : ''),
      roomWork2: new FormControl((details && details.roomWork2) ? details.roomWork2 : ''),
      roomWork3: new FormControl((details && details.roomWork3) ? details.roomWork3 : ''),
      roomWork4: new FormControl((details && details.roomWork4) ? details.roomWork4 : ''),
      roomWork5: new FormControl((details && details.roomWork5) ? details.roomWork5 : ''),
      roomWork6: new FormControl((details && details.roomWork6) ? details.roomWork6 : ''),
      roomWork7: new FormControl((details && details.roomWork7) ? details.roomWork7 : ''),
      comment: new FormControl((details && details.comment) ? details.comment : ''),
      noiseLevels: new FormControl((details && details.noiseLevels) ? details.noiseLevels : ''),
      noiseLevels1: new FormControl((details && details.noiseLevels1) ? details.noiseLevels1 : ''),
      noiseLevels2: new FormControl((details && details.noiseLevels2) ? details.noiseLevels2 : ''),
      noiseLevels3: new FormControl((details && details.noiseLevels3) ? details.noiseLevels3 : ''),
      impossible: new FormControl((details && details.impossible) ? details.impossible : ''),
      security: new FormControl((details && details.security) ? details.security : ''),
      security1: new FormControl((details && details.security1) ? details.security1 : ''),
      security2: new FormControl((details && details.security2) ? details.security2 : ''),
      security3: new FormControl((details && details.security3) ? details.security3 : ''),
      comment1: new FormControl((details && details.comment1) ? details.comment1 : ''),
      healthSafety: new FormControl((details && details.healthSafety) ? details.healthSafety : ''),
      healthSafety1: new FormControl((details && details.healthSafety1) ? details.healthSafety1 : ''),
      healthSafety2: new FormControl((details && details.healthSafety2) ? details.healthSafety2 : ''),
      healthSafety3: new FormControl((details && details.healthSafety3) ? details.healthSafety3 : ''),
      environment: new FormControl((details && details.environment) ? details.environment : ''),
      medicalKit: new FormControl((details && details.medicalKit) ? details.medicalKit : ''),
      medicalKit1: new FormControl((details && details.medicalKit1) ? details.medicalKit1 : ''),
      medicalKit2: new FormControl((details && details.medicalKit2) ? details.medicalKit2 : ''),
      medicalKit3: new FormControl((details && details.medicalKit3) ? details.medicalKit3 : ''),
      healthSurveillance: new FormControl((details && details.healthSurveillance) ? details.healthSurveillance : ''),
      healthSurveillance1: new FormControl((details && details.healthSurveillance1) ? details.healthSurveillance1 : ''),
      healthSurveillance2: new FormControl((details && details.healthSurveillance2) ? details.healthSurveillance2 : ''),
      healthSurveillance3: new FormControl((details && details.healthSurveillance3) ? details.healthSurveillance3 : ''),
      medicalName: new FormControl((details && details.medicalName) ? details.medicalName : ''),
      medicalDate: new FormControl((details && details.medicalDate) ? details.medicalDate : ''),
      medicalSign: new FormControl((details && details.medicalSign) ? details.medicalSign : ''),
      verifyName: new FormControl((details && details.verifyName) ? details.verifyName : ''),
    })
      if (this.user && this.user.isClient) {
          this.medicalChecklistForm.disable()
      }
  }

  onChangeEvent(value, formGroup, formControl) {
    console.log("value, formControl, formGroup", value, formControl, formGroup);

    if (formGroup == 'medicalChecklistForm')
      this.medicalChecklistForm.get(formControl).setValue(value);
  }



  // UTILITY



  selectClient(event) {
    console.log("event when client is selected", event);
    // let element = this.selectedClients.slice(-1)[0]
    // console.log("what is the last element of array", element);
    this.locationList = []
    this.selectedClients.forEach((item) => {
      this.locationList.push(item.location.title)
    })
    let location = this.locationList.reverse()
    console.log("location list", location);
    this.locationDetails = this.locationList.reverse().join(',')
    this.medicalChecklistForm.controls.locations.setValue(this.locationDetails);

  }


  addSignature() {
    this.openDialog(SignaturePadComponent).subscribe((data) => {
      console.log("data of sign", data);
      if (data == undefined) return

      let sign = data
      this.medicalSign = true
      this.medicalChecklistForm.patchValue({
        medicalSign: sign
      })
    })

  }


  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }


  compareObjects(o1: any, o2: any): boolean {
    // console.log("compareObjects called", o1._id, o2._id)
    return o1._id === o2._id;
  }


  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }


  downloadMedical() {
    this.loading=true;
    console.log("down load medical checklist form", this.medicalFormDetails);
    
    this.documentService.checklistdowload(this.medicalFormDetails._id).
     subscribe((response)=>{
       
       this.loading=false;
       this.handleSnackBar({ msg: "Download PDF Medical Checklist successfully!", button: "Ok" });
       console.log("download Sucessfully",response)
       let byteArray = new Uint8Array(response.data);

      console.log("======byteArray =======", byteArray)
      let blob = new Blob([byteArray], { type: 'application/pdf' });
      console.log("blobblobblobblobblob", blob)
      let location = []
      this.singleJobDetails.clients.forEach((item) => {
        location.push(item.location.title)
      })
      let title = 'Medical Checklist' + location.join('-') + '' + moment(new Date).format("DD-MM-YYYY")
      saveAs(blob,title);
     },
     (err)=>{
       this.loading=false;
       this.handleSnackBar({ msg: "Download PDF Failed", button: "Ok" });
      console.log("download pdf facing some issue",err);
     } )
  }




  // API CALL




  /**
   * Get medical form value
   */
    getMedicalFormValue() {
        this.loading = true
    this.documentService.getMedicalChecklistFormValue(this.jobId).subscribe((response) => {
      console.log("resposne of medical checklist form", response);
        if (response && response.length) {
            this.medicalFormDetails = response[0]
            this.isEdit = true
            this.createForm(this.medicalFormDetails.details.medicalChecklistForm)
            this.loading = false
            if (this.medicalFormDetails.details.medicalChecklistForm && this.medicalFormDetails.details.medicalChecklistForm.medicalSign != '') {
                this.medicalSign = true
            }
        } else {this.loading = false }
    }, error => {
      console.log("error while get medical form details", error);

    })


  }



  /**
   * Submit medical checklist form
   */
  submitMedicalForm() {
    console.log("final form value", this.medicalChecklistForm.value);
      this.loading = true
    if (this.isEdit == true) {
      let obj = {
        metaObj: {
          title: 'medicalChecklist',
        },
        jobId: this.jobId,
        details: {},
        onModel: 'mpjob',
        documentMetaId: this.medicalFormDetails.documentMetaId._id,
        documentId: this.medicalFormDetails._id,
      }

      let details = {
        medicalChecklistForm: this.medicalChecklistForm.value
      }
      obj['details'] = details
      this.documentService.updateForm(obj).subscribe((response) => {
        console.log("response of iqa form", response);
          this.handleSnackBar({ msg: "Data saved successfully!", button: "Ok" });
          this.loading = false
        this.router.navigate(['/mpjob/' + this.jobId], { queryParams: { currentTab: 3 } })
      }, error => {
              console.log("error while update form", error);
              this.loading = false
        this.handleSnackBar({ msg: "Something went wrong", button: "Ok" });
      })
    } else {
      let obj = {
        metaObj: {
          title: 'medicalChecklist',
        },
        jobId: this.jobId,
        details: {},
        onModel: 'mpjob'
      }

      let details = {
        medicalChecklistForm: this.medicalChecklistForm.value
      }
      obj['details'] = details
      this.documentService.addDocument(obj).subscribe((response) => {
        console.log("document resposne of iqa form", response);
        this.handleSnackBar({ msg: "Data saved successfully!!", button: "Ok" });
          this.router.navigate(['/mpjob/' + this.jobId], { queryParams: { currentTab: 3 } })
          this.loading = false
      }, error => {
              console.log("error while add iqa form", error);
              this.loading = false
        this.handleSnackBar({ msg: "Something went wrong", button: "Ok" });
      })
    }
  }
}
